var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewComfy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#263341",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5C5.55 7 6 7.45 6 8V16C6 16.55 5.55 17 5 17H3C2.45 17 2 16.55 2 16V8C2 7.45 2.45 7 3 7ZM8 19H16C16.55 19 17 18.55 17 18V6C17 5.45 16.55 5 16 5H8C7.45 5 7 5.45 7 6V18C7 18.55 7.45 19 8 19ZM19 7H21C21.55 7 22 7.45 22 8V16C22 16.55 21.55 17 21 17H19C18.45 17 18 16.55 18 16V8C18 7.45 18.45 7 19 7Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewComfy);
export default __webpack_public_path__ + "static/media/view-comfy.671cdc5a.svg";
export { ForwardRef as ReactComponent };